import * as React from 'react';

function SvgIconInteroperable(props) {
  return (
    <svg data-name="Interoperable v1" viewBox="0 0 624.06 545.23" {...props}>
      <path
        fill="#32cb87"
        d="M252.29,0,189.53,36.62l0,133.9-56.78,31L133,409.16,310.74,511.27l57.52-33,103.29,59.58,12.84,7.39,60-34.91.08-340.21Zm0,12.67L529.53,174.05,484.2,200.16,206,39.7ZM195,180,357.4,272.8l-46.66,26.84-161.4-94.7ZM310.71,306l0,.08h-.09Zm5.49,3.15,46.88-27V468.61L316.2,495.52ZM374,349,421,376v54.67L374,403.81ZM421,363.35l-46.93-27V269.69l-58.26-33.27V182.67L421,242.82ZM304.83,230.17,259,204V150.2l45.84,26.21Zm-161.1-15.83,161.53,94.77V495.5L144,402.82ZM374,469V416.42l57.88,33.1v-213L248.05,131.33v66.41L200.5,170.58l0-121.42L478.6,209.57V529.26Zm115.51,60.62V209.71l44-25.35L533.48,504Z"
      />
      <path
        fill="#32cb87"
        d="M190.53,298.28v77.19l68.22,39.06V337.05ZM242,340.14l-40.56,22.68V317.09ZM207,372.28l40.82-22.82v46.19Z"
      />
    </svg>
  );
}

export default SvgIconInteroperable;
